import { render, staticRenderFns } from "./SmsTemplates.vue?vue&type=template&id=2bb79485"
import script from "./SmsTemplates.vue?vue&type=script&lang=js"
export * from "./SmsTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports